import React from 'react';

const SafeplanTermsAndConditions = () => {
  return (
    <>
      <style>
        {`
          .note-section-container-unique {
            padding: 0px;
            background-color: white;
            border-radius: 0px;
            font-family: sans-serif;
            width: 100%;
            margin: 0 auto;
          }

          .note-section-heading-unique {
            text-align: center;
            font-size: 22px;
            margin-bottom: 20px;
            font-weight: bold;
          }

          .note-section-paragraph-unique {
            font-size: 14px;
            line-height: 1.6;
            margin-bottom: 12px;
            color: #333;
          }

          .note-section-agree-unique {
            text-align: center;
            font-weight: 500;
            font-size: 15px;
            margin-top: 25px;
          }
        `}
      </style>

      <div className="note-section-container-unique">
        <h3 className="note-section-heading-unique">Note</h3>

        <div className="note-section-paragraph-unique">
          <p>
            1. Dr Planete is merely providing an Interface Platform to the client wherein the client can post/request to post his lawful requirements as eligible on the platform and seek the response from the prospective Responding Entity on this platform.
          </p>
        </div>
        <div className="note-section-paragraph-unique">
          <p>
            2. Dr Planete shall not have any privity with respect to any terms and conditions or any agreements etc. or with respect to any transactions, or with respect to any interactions, etc. which may be entered into by the client and the Responding Entity once they establish contact through the platform.
          </p>
        </div>
        <div className="note-section-paragraph-unique">
          <p>
            3. Dr Planete does not give any guarantee to the client with regard to the satisfaction of his requirements. Merely, posting of the requirements by the client shall not be presumed or taken as a guarantee to meet and satisfy the requirements of the client. The client understands and agrees that this Service Interface Platform is merely an interface between the client and the Responding Entity.
          </p>
        </div>
        <div className="note-section-paragraph-unique">
          <p>4. All charges are inclusive of all taxes applicable and are non-refundable.</p>
        </div>
        <div className="note-section-paragraph-unique">
          <p>
            5. Dr Planete shall not be responsible for any future dispute with regard to your competence and authorization by your Organization.
          </p>
        </div>
        <div className="note-section-paragraph-unique">
          <p>
            6. You and your Organization shall be duly responsible for all the consequences that may arise out of the use of this Service Interface Platform. It’s the responsibility of the client to keep updated and comply with the terms and conditions of the interface platform.
          </p>
        </div>

        <p className="note-section-agree-unique">By continuing, I agree to all Terms & Conditions</p>
      </div>
    </>
  );
};

export default SafeplanTermsAndConditions;
